

<router-outlet></router-outlet>
<p-toast></p-toast>
<p-confirmDialog i18n-header header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>